import { Observable, of } from "rxjs";
import { switchMap, mergeMap, map, withLatestFrom, catchError } from "rxjs/operators";
import { fromFetch } from "rxjs/fetch";
import { Location } from "./location";
import { Geocoder } from "./geocoder";
export class POISearch extends Geocoder {
    _locations = {};
    constructor(inputField, config_opt) {
        super(inputField);
        const newConf = config_opt || {};
        this.configure(newConf);
    }
    get query$() {
        const query$ = this.inputSearch$(300).pipe(withLatestFrom(this.configuration$), switchMap(([searchTerm, configuration]) => {
            const queryproperties = [configuration.queryproperty];
            const filters = [];
            for (let i = 0; i < configuration.filters.length; i++) {
                queryproperties.push(configuration.filters[i].property);
                filters.push(`${configuration.filters[i].property}_${configuration.filters[i].operator}=${configuration.filters[i].value}`);
            }
            return fromFetch(`${configuration.host}/${configuration.dataset}/${configuration.layer}?count=false&offset=0&limit=10&no_geom=false&requestoutputsrid=4326&queryable=${queryproperties.join(",")}&${configuration.queryproperty}_like=${searchTerm}&${filters.join("&")}`, {
                headers: {
                    Accept: "application/json",
                    "x-api-key": configuration.apiKey,
                    Authorization: `Bearer ${configuration.accessToken}`,
                },
                credentials: "omit",
            }).pipe(mergeMap((response) => {
                if (response.ok) {
                    return response.json();
                }
                else {
                    return of(response.status);
                }
            }), map((json) => {
                const res = [];
                for (const feature of json.features) {
                    const _geopos = Location.createFromGeoJSON(feature, "artcode", "name");
                    res.push(_geopos);
                    this._locations[_geopos.locationId] = _geopos;
                }
                return res;
            }), catchError(() => {
                console.error("POISearch: error fetching or parsing data.");
                return of([]);
            }));
        }));
        return query$;
    }
    select(locationId) {
        return new Promise((resolve, reject) => {
            if (this._locations[locationId]) {
                resolve(this._locations[locationId]);
            }
            else {
                reject(Error("no location found for the given id"));
            }
        });
    }
    _getDefaultConfiguration() {
        return {
            name: "geofeatureserver",
            dataset: "geob_poisearch",
            layer: "pointlayer",
            host: "https://api.infra3d.com/geofeatureserver/",
            filters: [
                {
                    property: "dataset",
                    operator: "eq",
                    value: "basel",
                },
            ],
            queryproperty: "name",
            apiKey: "",
            accessToken: "",
        };
    }
}
//# sourceMappingURL=poisearch.js.map